import { render } from "./MainQuiz.vue?vue&type=template&id=4258f120"
import script from "./MainQuiz.vue?vue&type=script&lang=js"
export * from "./MainQuiz.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__